var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"Photovoltaic"}},[_c('div',{staticClass:"subcontainer-one column-center"},[_c('pvWiringLine')],1),_c('div',{staticClass:"subcontainer-thr"},[_c('Diagram')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }